import React from 'react';
import styled from '@emotion/styled';

const SpinnerWrapper = styled.div`
  background-color: grey;
  width: 90px;
  height: 90px;
  border-radius: 6px;
  position: relative;

  @keyframes cc-fade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.25;
    }
  }

  div {
    width: 5%;
    height: 13%;
    top: 42%;
    background: #ffffff;
    position: absolute;
    left: 47%;
    opacity: 0;
    -webkit-animation: cc-fade 1s linear infinite;
    -moz-animation: cc-fade 1s linear infinite;
    -ms-animation: cc-fade 1s linear infinite;
    -o-animation: cc-fade 1s linear infinite;
    animation: cc-fade 1s linear infinite;
    border-radius: 50px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  }
  .spinner-slice-1 {
    transform: rotate(0deg) translate(0, -142%);
    -webkit-transform: rotate(0deg) translate(0, -142%);
    -moz-transform: rotate(0deg) translate(0, -142%);
    -ms-transform: rotate(0deg) translate(0, -142%);
    -o-transform: rotate(0deg) translate(0, -142%);
    animation-delay: 0s;
    -webkit-animation-delay: 0s;
    -moz-animation-delay: 0s;
    -ms-animation-delay: 0s;
    -o-animation-delay: 0s;
  }
  .spinner-slice-2 {
    transform: rotate(30deg) translate(0, -142%);
    -webkit-transform: rotate(30deg) translate(0, -142%);
    -moz-transform: rotate(30deg) translate(0, -142%);
    -ms-transform: rotate(30deg) translate(0, -142%);
    -o-transform: rotate(30deg) translate(0, -142%);
    animation-delay: -0.9167s;
    -webkit-animation-delay: -0.9167s;
    -moz-animation-delay: -0.9167s;
    -ms-animation-delay: -0.9167s;
    -o-animation-delay: -0.9167s;
  }
  .spinner-slice-3 {
    transform: rotate(60deg) translate(0, -142%);
    -webkit-transform: rotate(60deg) translate(0, -142%);
    -moz-transform: rotate(60deg) translate(0, -142%);
    -ms-transform: rotate(60deg) translate(0, -142%);
    -o-transform: rotate(60deg) translate(0, -142%);
    animation-delay: -0.833s;
    -webkit-animation-delay: -0.833s;
    -moz-animation-delay: -0.833s;
    -ms-animation-delay: -0.833s;
    -o-animation-delay: -0.833s;
  }
  .spinner-slice-4 {
    transform: rotate(90deg) translate(0, -142%);
    -webkit-transform: rotate(90deg) translate(0, -142%);
    -moz-transform: rotate(90deg) translate(0, -142%);
    -ms-transform: rotate(90deg) translate(0, -142%);
    -o-transform: rotate(90deg) translate(0, -142%);
    animation-delay: -0.75s;
    -webkit-animation-delay: -0.75s;
    -moz-animation-delay: -0.75s;
    -ms-animation-delay: -0.75s;
    -o-animation-delay: -0.75s;
  }
  .spinner-slice-5 {
    transform: rotate(120deg) translate(0, -142%);
    -webkit-transform: rotate(120deg) translate(0, -142%);
    -moz-transform: rotate(120deg) translate(0, -142%);
    -ms-transform: rotate(120deg) translate(0, -142%);
    -o-transform: rotate(120deg) translate(0, -142%);
    animation-delay: -0.667s;
    -webkit-animation-delay: -0.667s;
    -moz-animation-delay: -0.667s;
    -ms-animation-delay: -0.667s;
    -o-animation-delay: -0.667s;
  }
  .spinner-slice-6 {
    transform: rotate(150deg) translate(0, -142%);
    -webkit-transform: rotate(150deg) translate(0, -142%);
    -moz-transform: rotate(150deg) translate(0, -142%);
    -ms-transform: rotate(150deg) translate(0, -142%);
    -o-transform: rotate(150deg) translate(0, -142%);
    animation-delay: -0.5833s;
    -webkit-animation-delay: -0.5833s;
    -moz-animation-delay: -0.5833s;
    -ms-animation-delay: -0.5833s;
    -o-animation-delay: -0.5833s;
  }
  .spinner-slice-7 {
    transform: rotate(180deg) translate(0, -142%);
    -webkit-transform: rotate(180deg) translate(0, -142%);
    -moz-transform: rotate(180deg) translate(0, -142%);
    -ms-transform: rotate(180deg) translate(0, -142%);
    -o-transform: rotate(180deg) translate(0, -142%);
    animation-delay: -0.5s;
    -webkit-animation-delay: -0.5s;
    -moz-animation-delay: -0.5s;
    -ms-animation-delay: -0.5s;
    -o-animation-delay: -0.5s;
  }
  .spinner-slice-8 {
    transform: rotate(210deg) translate(0, -142%);
    -webkit-transform: rotate(210deg) translate(0, -142%);
    -moz-transform: rotate(210deg) translate(0, -142%);
    -ms-transform: rotate(210deg) translate(0, -142%);
    -o-transform: rotate(210deg) translate(0, -142%);
    animation-delay: -0.41667s;
    -webkit-animation-delay: -0.41667s;
    -moz-animation-delay: -0.41667s;
    -ms-animation-delay: -0.41667s;
    -o-animation-delay: -0.41667s;
  }
  .spinner-slice-9 {
    transform: rotate(240deg) translate(0, -142%);
    -webkit-transform: rotate(240deg) translate(0, -142%);
    -moz-transform: rotate(240deg) translate(0, -142%);
    -ms-transform: rotate(240deg) translate(0, -142%);
    -o-transform: rotate(240deg) translate(0, -142%);
    animation-delay: -0.333s;
    -webkit-animation-delay: -0.333s;
    -moz-animation-delay: -0.333s;
    -ms-animation-delay: -0.333s;
    -o-animation-delay: -0.333s;
  }
  .spinner-slice-10 {
    transform: rotate(270deg) translate(0, -142%);
    -webkit-transform: rotate(270deg) translate(0, -142%);
    -moz-transform: rotate(270deg) translate(0, -142%);
    -ms-transform: rotate(270deg) translate(0, -142%);
    -o-transform: rotate(270deg) translate(0, -142%);
    animation-delay: -0.25s;
    -webkit-animation-delay: -0.25s;
    -moz-animation-delay: -0.25s;
    -ms-animation-delay: -0.25s;
    -o-animation-delay: -0.25s;
  }
  .spinner-slice-11 {
    transform: rotate(300deg) translate(0, -142%);
    -webkit-transform: rotate(300deg) translate(0, -142%);
    -moz-transform: rotate(300deg) translate(0, -142%);
    -ms-transform: rotate(300deg) translate(0, -142%);
    -o-transform: rotate(300deg) translate(0, -142%);
    animation-delay: -0.1667s;
    -webkit-animation-delay: -0.1667s;
    -moz-animation-delay: -0.1667s;
    -ms-animation-delay: -0.1667s;
    -o-animation-delay: -0.1667s;
  }
  .spinner-slice-12 {
    transform: rotate(330deg) translate(0, -142%);
    -webkit-transform: rotate(330deg) translate(0, -142%);
    -moz-transform: rotate(330deg) translate(0, -142%);
    -ms-transform: rotate(330deg) translate(0, -142%);
    -o-transform: rotate(330deg) translate(0, -142%);
    animation-delay: -0.0833s;
    -webkit-animation-delay: -0.0833s;
    -moz-animation-delay: -0.0833s;
    -ms-animation-delay: -0.0833s;
    -o-animation-delay: -0.0833s;
  }
`;

const Spinner = () => {
  return (
    <SpinnerWrapper>
      <div className="spinner-slice-1"></div>
      <div className="spinner-slice-2"></div>
      <div className="spinner-slice-3"></div>
      <div className="spinner-slice-4"></div>
      <div className="spinner-slice-5"></div>
      <div className="spinner-slice-6"></div>
      <div className="spinner-slice-7"></div>
      <div className="spinner-slice-8"></div>
      <div className="spinner-slice-9"></div>
      <div className="spinner-slice-10"></div>
      <div className="spinner-slice-11"></div>
      <div className="spinner-slice-12"></div>
    </SpinnerWrapper>
  );
};
export { Spinner };
